module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/icon--calendar-42178557.png";